import { SERVICE_DESK_PROJECT } from '@atlassian/jira-common-constants/src/project-types';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import type { ProjectContext } from '@atlassian/jira-router-resources-project-context/src/services/project-context/types.tsx';
import { toProjectKey } from '@atlassian/jira-shared-types/src/general.tsx';
import { useResource, type RouteResourceError } from '@atlassian/react-resource-router';

type ProjectContextService = () => {
	data: ProjectContext;
	loading: boolean;
	error: RouteResourceError;
};

export const DEFAULT_CONTEXT: ProjectContext = {
	projectKey: toProjectKey(''),
	projectId: -1,
	projectUuid: undefined,
	projectName: '',
	avatarUrl: '',
	simplified: false,
	projectType: SERVICE_DESK_PROJECT,
	isProjectAdmin: false,
};

// @ts-expect-error - TS2322 - Type '() => { data: ProjectContext; loading: boolean; error: Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null; }' is not assignable to type 'ProjectContextService'.
const useProjectContext: ProjectContextService = () => {
	const { data, loading, error } = useResource(projectContextResource);

	return {
		data: data || DEFAULT_CONTEXT,
		loading,
		error,
	};
};

export default useProjectContext;
